import React, { useEffect } from 'react';

const useTimeout = (callback: () => void, delay = 0) => {
  const timeoutRef = React.useRef<any>(null);
  const savedCallback = React.useRef(callback);

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    const tick = () => savedCallback.current();
    timeoutRef.current = setTimeout(tick, delay);
    return () => clearTimeout(timeoutRef.current);
  }, [delay]);

  return timeoutRef;
};

export default useTimeout;
